import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import { Overline, Reveal } from "@/components/motion";

const Testimonials = () => (
  <section
    id="testimonials"
    data-testid="testimonials-section"
    className="relative border-t border-white/5 bg-stone-900/30 py-28 md:py-36"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-16">
        <Overline>From the Tea Table</Overline>
        <h2 className="mt-5 max-w-2xl font-serif text-4xl leading-[1.05] tracking-tight text-stone-100 sm:text-5xl lg:text-6xl">
          Poured, sipped, <em className="not-italic text-amber-500">remembered</em>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.12} className={i === 1 ? "md:mt-14" : ""}>
            <figure
              data-testid={`testimonial-card-${i}`}
              className="group flex h-full flex-col justify-between border border-white/5 bg-stone-950/60 p-8 transition-colors duration-500 hover:border-amber-600/30"
            >
              <div>
                <div className="mb-6 flex gap-1.5" aria-label="Five star review">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="h-3.5 w-3.5 fill-amber-500 text-amber-500" />
                  ))}
                </div>
                <blockquote className="font-serif text-xl leading-relaxed tracking-tight text-stone-200 md:text-2xl">
                  “{t.quote}”
                </blockquote>
              </div>
              <figcaption className="mt-8">
                <p className="text-sm font-medium text-stone-100">{t.name}</p>
                <p className="mt-0.5 text-xs uppercase tracking-[0.25em] text-stone-500">{t.place}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
